import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { injectTSDI } from '../../core/common/tsdi';
import { BottomPaddedGridItemS } from '../styles';
import { ContractWithdrawalStore } from './contract-withdrawal-store';
import { ContractsViewContainer } from './contracts-view-container';
import { ContractWithdrawalManualForm } from './forms/contract-withdrawal-manual-form';
import { MemberDataForm } from './forms/contract-withdrawal-member-data-form';

export const ContractWithdrawalPage = observer(() => {
    const { hasContracts } = injectTSDI(ContractWithdrawalStore);
    return (
        <Grid container>
            <BottomPaddedGridItemS item xs={12}>
                <MemberDataForm />
            </BottomPaddedGridItemS>

            <BottomPaddedGridItemS item xs={12}>
                <ContractsViewContainer />
            </BottomPaddedGridItemS>
            {!hasContracts && (
                <Grid item xs={12}>
                    <ContractWithdrawalManualForm />
                </Grid>
            )}
        </Grid>
    );
});
